export const Search = () => {
  return (
    <div className="bg-vid-black-100 w-[450px] h-[60px] rounded-full hidden lg:flex items-center px-4">
      <img src="/search.svg" alt="Search" width={20} height={20} />
    </div>
  );
};
